import getCollectionDataByArray from "./getCollectionDataByArray";

export default async function getCollectionDataById(firebase, collection, ids, options) {
	return getCollectionDataByArray(firebase, collection, firebase.firestore.FieldPath.documentId(), ids, options);
}
